import { t } from "i18next";
import { useState, useContext, useEffect } from "react";
// import "../App.css";
import { WindowContext, WingConfigurationContext } from "../App.js";
import product_2w from "../images/configurationIcons/1400-s.svg";

function Configuration() {
  const { currentWindow, setCurrentWindow } = useContext(WindowContext);
  const { wingConfiguration, setWingConfiguration } = useContext(WingConfigurationContext);

  useEffect(() => {
    setWingConfiguration({
      position: 'left-wing',
      horizontalMount: 0,
      verticalMount: 0
    });
  }, [currentWindow]);

  return (
    <>
      <div className="panel-section panel-section-first">
        <div className="section-header section">{t('config')}</div>
        <div className="line"></div>
        <div className="window-picker">
          <img
            src={product_2w}
            id="2w"
            alt=""
            onClick={() => { setCurrentWindow("2w") }}
            className={"product__icon_window" + (currentWindow === "2w" ? " active" : "")}
          />
        </div>
      </div>
    </>
  );
}

export default Configuration;
